import { TApplicationState } from '../../types/redux';

export function getBuilders(state: TApplicationState) {
  const {
    newbuilding: { builders },
  } = state;

  if (builders) {
    return builders;
  }

  return [];
}
